import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND}/api`;

// Public payment/package endpoints (no auth).
export const getPackages = () => axios.get(`${API}/payments/packages`).then((r) => r.data);

export const getCurrency = () => axios.get(`${API}/payments/currency`).then((r) => r.data);

export const createCheckout = (payload) =>
  axios.post(`${API}/payments/checkout`, payload).then((r) => r.data);

export const getPaymentStatus = (sessionId) =>
  axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);

export const createBankOrder = (payload) =>
  axios.post(`${API}/payments/bank-order`, payload).then((r) => r.data);
